import { defineCustomElement } from "vue";
import VCBannerContabil from "./VCBannerContabil.ce.vue";
import { Register } from "@/ui/vue-components/components";

const path = { tag: "vc-contabil-banner", component: VCBannerContabil };

const _register: Register = {
  register() {
    if (!customElements.get(path.tag)) {
      const CustomElement = defineCustomElement(path.component);
      customElements.define(path.tag, CustomElement);
    }
  }
};

export default _register;
